import React, { useEffect } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import Banner from "../assets/images/FreeImranKhan/banner.jpg";

const FreeImranKhan = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const ARREST_DATE_UTC = new Date(Date.UTC(2023, 7, 5));
    const daysSinceUTC = (fromDate) => {
        const now = new Date();
        const todayUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        const startUTC = Date.UTC(fromDate.getUTCFullYear(), fromDate.getUTCMonth(), fromDate.getUTCDate());
        return Math.floor((todayUTC - startUTC) / 86400000);
    };
    const daysInDetention = daysSinceUTC(ARREST_DATE_UTC);
    return (
        <React.Fragment>
            <Helmet>
                <title>Free Imran Khan | First Pakistan Global</title>
            </Helmet>

            <Header />

            {/* Hero */}
            <section id="why-ik-freedom-matters">
                <div className="text-center">
                    <div
                        className="bg-common py-5"
                        style={{ backgroundImage: `url(${Banner})`, backgroundPosition: 'center -70px', backgroundSize: 'cover', backgroundAttachment: "fixed" }}
                    >
                        {/* testing <img src={'/images/WhyIKFreedomMatters/banner.png'} alt="Why Imran Khan's Freedom Matters" className="img-fluid d-md-none" /> */}
                        <div className="text-white fs-ss-68 py-5 py-md-5 my-md-5 overlay-content">
                            <div className="fw-700 text-uppercase upper-heading" style={{ display: "inline-block" }}>
                                <div className="fw-700">Free <span style={{ color: "#51c482", opacity: "0.9" }}>Imran Khan</span></div>
                                <span className="lower-heading"><span style={{ color: "#51c482", marginRight: "5px", fontWeight: "900" }}>{daysInDetention} days </span> in unjust detention</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Lead / Dek */}
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-4 text-md-center">
                                <span className="text-ss-primary">
                                    “Hold Asim Munir accountable if anything happens to me in jail.”
                                </span>{" "}
                                <span style={{ display: "inline-block" }}>— Imran Khan</span>
                            </h3>

                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                On August 5, 2023, former Prime Minister Imran Khan — leader of the world’s fifth most populous country — was illegally arrested by Pakistan’s military regime under General Asim Munir.
                                <div className="py-1" />
                                Khan has now spent <strong>{daysInDetention} days in unjust detention</strong> under inhumane conditions — targeted for challenging Pakistan’s unelected military elite and deep state.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: Descent */}
                <div className="container-fluid" id="descent">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                What Has Imran Khan Endured?
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                <ul>
                                    <li>22 hrs/day solitary confinement in a 6x8 cell, extreme heat without electricity</li>
                                    <li>Family, wife, and party leadership jailed; barred from seeing children for 7 months</li>
                                    <li>Over 200 fabricated cases, denied legal counsel, under surveillance in rare visits</li>
                                    <li>No independent medical care, declining health, suspected poisoning</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-4 py-md-5" />
                {/* Section: Descent */}
                <div className="container-fluid" id="descent">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                Pakistan Under Undeclared Martial Law Imposed by General Asim Munir:
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                <ul>
                                    <li>Constitution upended, judiciary trampled, Feb 2024 election stolen</li>
                                    <li>Social media banned, internet throttled, media silenced</li>
                                    <li>Journalists persecuted, civilians tried in military courts, peaceful protesters shot</li>
                                    <li>U.S. citizens targeted, diaspora activists harassed abroad</li>
                                </ul>
                                <p>These actions appear aimed at one goal: imprisoning Imran Khan and eliminating any challenge to Munir’s military regime.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: Why America Should Care */}
                <div className="container-fluid" id="why-america-should-care">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                Why America Should Care
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                Some in Washington dismiss Khan’s fate as an internal affair. It is not. Pakistan is the 5th most populous nuclear-armed nation at the crossroads of South Asia, bordering China, India, Iran, and Afghanistan. Its stability — or instability — directly affects U.S. interests.
                                <div className="py-1" />
                                When in office, Khan advanced those interests. He facilitated the Afghan peace deal that allowed America to withdraw from its longest war. He promoted regional stability and earned international recognition for his leadership during the COVID-19 crisis. Even President Donald Trump publicly praised him as a trusted partner.
                                <div className="py-1" />
                                A Pakistan run by generals, however, is brittle and volatile. It risks fueling extremism, destabilizing the region, and undermining U.S. credibility. Already, America’s silence is seen by many in Pakistan’s diaspora as tacit support for dictatorship.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: What Washington Can Do */}
                <div className="container-fluid" id="what-washington-can-do">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                On behalf of the Pakistani-American diaspora, we call on:
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                <strong>President Trump, the U.S. administration, and Members of Congress,</strong> to pressure the illegal regime in Pakistan to:
                                <div className="py-2" />
                                <ul className="">
                                    <li>
                                        Demand justice for Imran Khan and ALL political prisoners
                                    </li>
                                    <li>
                                        Implement Global Magnitsky sanctions on human rights violators
                                    </li>
                                    <li>
                                        Uphold constitutional civilian supremacy, rule of law, and judicial independence
                                    </li>
                                    <li>
                                        Ensure free, fair, and transparent elections under neutral international observers
                                    </li>
                                    <li>
                                        Demand that General Asim Munir retires on time and steps down at the end of his 3-year term
                                    </li>
                                </ul>
                                <div className="py-1" />
                                <p><strong>Support Pakistan Democracy Act – H.R. 2311</strong> (Rep. Joe Wilson): Demands sanctions on Gen. Asim Munir and free Imran Khan and all political prisoners.</p>
                                <p><strong>Support Pakistan Freedom & Accountability Act – H.R. 5271</strong> (Rep. Bill Huizenga): Imposes sanctions on those behind human rights abuses, election rigging, and repression.</p>
                                <p><strong>Join us in standing with Pakistan’s 250 million people living under authoritarian rule.</strong></p>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Section: Test of Credibility */}
                <div className="container-fluid" id="test-of-credibility">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">


                            {/* Prepared by / Attribution */}

                            <div className="border rounded-4 p-3 p-md-4 bg-light">
                                <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                    <span className="fw-600">Prepared by First Pakistan Global (FPG)</span>
                                    <div className="py-1" />
                                    A U.S.-based nonprofit dedicated to advancing democracy, human
                                    rights, and the rule of law in Pakistan.
                                    <div className="py-1" />
                                    <a
                                        href="https://x.com/FirstPakGlobal"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-ss-primary fw-600"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M13.795 10.533 20.68 2h-3.073l-5.255 6.517L7.69 2H1l7.806 10.91L1.47 22h3.074l5.705-7.07L15.31 22H22l-8.205-11.467Zm-2.38 2.95L9.97 11.464 4.36 3.627h2.31l4.528 6.317 1.443 2.02 6.018 8.409h-2.31l-4.934-6.89Z" />
                                        </svg>  https://x.com/FirstPakGlobal
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />
            </section>

            <Footer />
            <style>{`
  /* Parent needs positioning so the overlay can anchor */
  .bg-common.py-5 { 
    position: relative; 
  }

  /* Semi-transparent overlay on top of the background image */
  .bg-common.py-5::after {
    content: "";
    position: absolute;
    inset: 0;                /* top:0; right:0; bottom:0; left:0 */
    background: rgba(18, 50, 8, 0.54);
    z-index: 1;              /* sits above the background, below the content */
    pointer-events: none;    /* overlay won’t block clicks */
  }

  /* Ensure your text/content sits above the overlay */
  .bg-common .overlay-content {
    position: relative;
    z-index: 2;
        line-height: 80px;
  }
    .upper-heading{
    line-height: 27px;
    }
    .lower-heading{
font-size: 15px;
    letter-spacing: 2px;
    display: inline-flex;
    justify-content: end;
    width: 100%;
    /* font-style: italic; */
    padding-right: 3px;
    opacity: 0.7;}
    @media (max-width: 768px) {
        .upper-heading{
          line-height: 65px;
        }
        .lower-heading{
            justify-content: center;
            line-height: normal;
            position: relative;
            top: -24px;
        }
    }
`}</style>
        </React.Fragment>

    );

};

export default FreeImranKhan;
